<template>
  <div class="card">
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div
              class="absolute left top bottom h-60 v-strock-2 bg-primary"
              :class="boxEquipmentType ? 'bg-info' : 'bg-primary'"
            ></div>
            <p v-if="boxEquipmentType" class="text-muted mb-2">
              {{ $t('dashboards.discreteValuePlot.counterAllTime') }}
              <br />
              <span class="smallText">
                {{ $t('dashboards.discreteValuePlot.finishedProducts') }}
              </span>
            </p>
            <p v-else class="text-muted mb-2">
              {{ $t('dashboards.operationValuePlot.runningHoursAllTime') }}
            </p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2">
                {{ `${overallValueText}` }}
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="card aligner-wrapper">
          <div class="card-body">
            <div
              class="absolute left top bottom h-60 v-strock-2"
              :class="boxEquipmentType ? 'bg-info' : 'bg-primary'"
            ></div>
            <p v-if="boxEquipmentType" class="text-muted mb-2">
              {{ $t('dashboards.discreteValuePlot.counterPeriod') }}
              {{ tabPeriodText }}
              <br />
              <span class="smallText">
                {{ $t('dashboards.discreteValuePlot.finishedProducts') }}
              </span>
            </p>
            <p v-else class="text-muted mb-2">
              {{ $t('dashboards.operationValuePlot.runningHoursInPeriod') }}
              {{ tabPeriodText }}
            </p>
            <div class="d-xl-flex align-items-center">
              <h1 class="font-weight-medium mb-2">
                {{ `${valueInPeriodText}` }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import operationValuePeriodStats from '@/api/boxinfo/operationValuePeriodStats.gql';

export default {
  name: 'BoxOperationValuePlot',
  props: {
    deviceId: String,
    period: Object,
    tabPeriodText: String,
    boxEquipmentType: Number,
  },
  apollo: {
    valueStats: {
      query: operationValuePeriodStats,
      variables() {
        return {
          deviceId: this.deviceId,
          period: this.period,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).operationValuePeriodStats || {};
      },
      skip() {
        return !this.deviceId || !this.period;
      },
      pollInterval: 30000,
    },
  },
  computed: {
    tabNames() {
      return [this.$t('box.target'), this.$t('box.cumulative')];
    },
    currentOperValCaption() {
      return `${this.tabNames[0]}`;
    },
    allOperValCaption() {
      return `${this.tabNames[1]}`;
    },
    unitName() {
      return (
        (((this.sensorData || {}).type || {}).measurementUnit || {}).shortName ||
        this.$t('dashboards.operationValuePlot.units')
      );
    },

    valueInPeriodText() {
      const total = (this.valueStats || {}).valueInPeriod || 0;
      return total
        ? this.boxEquipmentType
          ? total
          : `${Math.floor(total / 60).toLocaleString()} ${this.$t('dashboards.hours')} ${Math.floor(
              total % 60,
            )} ${this.$t('dashboards.minutes')}`
        : this.$t('dashboards.noData');
    },
    overallValueText() {
      const total = (this.valueStats || {}).overallValue || 0;
      return total
        ? this.boxEquipmentType
          ? total
          : `${Math.floor(total / 60).toLocaleString()} ${this.$t('dashboards.hours')} ${Math.floor(
              total % 60,
            )} ${this.$t('dashboards.minutes')}`
        : this.$t('dashboards.noData');
    },
  },
  methods: {
    formatNumber(v) {
      return Number(v.toPrecision(4)).toLocaleString();
    },
  },
};
</script>

<style scoped>
#wrapper {
  position: block;
  background: white;
  border: 1px solid #000;
  box-shadow: 0 22px 35px -16px rgba(0, 0, 0, 0.71);
  height: 200px !important;
  min-height: 200px !important;
  max-height: 300px !important;
  margin: 0 auto;
}
#chart-bar {
  position: relative;
  margin-top: -70px;
}
.tab-solid {
  margin-bottom: 0px !important;
}
.dot-opacity-loader {
  position: absolute;
  height: 25px;
  left: calc(50% - 50px);
}
.dot-opacity-loader span {
  background-color: #0090e7;
  margin: 5px 5px;
}
</style>
